/*
  This file is generated from build-scripts/postinstall-scripts/app-config/environmentMapper.ts
  To keep the build system neat and consistent, we are copying this file to the libs/utils/lib/environmentMapper.ts during postinstall
  If you'd like to update this file, please do so in build-scripts/postinstall-scripts/app-config/environmentMapper.ts
  Then, re-run the postinstall script by running `pnpm install` in the root directory
*/
export type AWS_REGION = 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2';

export type LaneTag =
  | 'localhost'
  | 'd1'
  | 'd2'
  | 'q1'
  | 'q2'
  | 'i1'
  | 'u1'
  | 'st1'
  | 'pe1'
  | 'p1';

export const getEnvByLane = (lane: LaneTag) => {
  // d1=unused, d2=main/awsdev, q1=awsqa/west, q2=qa/east, i1=awsint, u1=uat, st1=stg, pe1=peg, p1=prod
  switch (lane) {
    case 'localhost':
    case 'd2':
      return 'awsdev';
    case 'q1':
      return 'awsqa';
    case 'q2':
      return 'qa';
    case 'i1':
      return 'awsint';
    case 'pe1':
      return 'awspeg';
    case 'st1':
      return 'stg';
    case 'u1':
      return 'uat';
    case 'p1':
      return 'prod';
    case 'd1':
    default:
      throw new Error(`getEnvByLane(${lane}) is not supported`);
  }
};

export const getFlattenedEnvByLane = (lane: LaneTag) => {
  switch (lane) {
    case 'localhost':
    case 'd1':
    case 'd2':
      return 'dev';
    case 'q1':
    case 'q2':
      return 'qa';
    case 'i1':
      return 'int';
    case 'pe1':
      return 'peg';
    case 'st1':
      return 'stg';
    case 'u1':
      return 'uat';
    case 'p1':
      return 'prod';
    default:
      throw new Error(`getEnvByLane(${lane}) is not supported`);
  }
};
